// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-35e8188b] .yaml-editor{flex:1;min-height:200px}[data-v-35e8188b] .yaml-editor .code-mirror .CodeMirror{position:static;height:auto;min-height:200px}[data-v-35e8188b] .info-box{margin-bottom:10px}.box[data-v-35e8188b]{position:relative}.remove[data-v-35e8188b]{position:absolute;top:10px;right:10px;padding:0}.bootOrder[data-v-35e8188b]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
